export const getDataFromDocuments = docs => {
  const ret = []
  for (const doc of docs) ret.push({ ...doc.data(), id: doc.id })
  return ret
}